export const types = [
  "all",
  "undailed",
  "follow up",
  "not attending",
  "buyer",
  "seller",
  "both",
  "not intrested",
  "wrong number",
];
